import TextDirection from "@components/_shared/TextDirection";
import { useTranslations } from "@context/translations";
import ChevronIcon from "@icons/chevron.svg";
import clsx from "clsx";
import Link from "next/link";
import { FC } from "react";
import styles from "./BreadCrumb.module.scss";

interface BreadcrumbProps {
  breadcrumbs: Array<BreadCrumb>;
  isRtl: boolean;
}

const Breadcrumb: FC<BreadcrumbProps> = ({
  breadcrumbs = [],
  isRtl = false,
}) => {
  const translate = useTranslations();

  return (
    <div
      className={clsx(styles.container, isRtl && styles.rtl)}
      data-testid="breadcrumbs"
    >
      <div className={styles.breadcrumbItem}>
        <Link href="/">
          <a data-testid="breadcrumb-link">{translate("home")}</a>
        </Link>
      </div>
      {breadcrumbs.length !== 0 &&
        breadcrumbs.map((breadcrumb) => {
          return (
            <div key={breadcrumb.name} className={styles.breadcrumbItem}>
              <span className={styles.arrowIcon}>
                <ChevronIcon />
              </span>
              <Link href={breadcrumb.path}>
                <a data-testid="breadcrumb-link">
                  <TextDirection text={breadcrumb.name} />
                </a>
              </Link>
            </div>
          );
        })}
    </div>
  );
};

export default Breadcrumb;
